import type { TChatState } from "./chat-domain.types";

import {
  conversationControllerInitialState,
  conversationListInitialState,
} from "./conversation";
import {
  messageListInitialState,
  newMessageInitialState,
  messageUnreadInitialState,
  messageStatusInitialState,
} from "./message";
import { webSocketInitialState } from "./connection";
import { tabsInitialState, phoneInitialState } from "./ui";

export const chatStoreInitialState: TChatState = {
  conversation: conversationControllerInitialState,
  conversationTo: conversationListInitialState,
  conversationFrom: conversationListInitialState,
  messageList: messageListInitialState,
  webSocket: webSocketInitialState,
  tabs: tabsInitialState,
  phone: phoneInitialState,
  newMessage: newMessageInitialState,
  messageUnread: messageUnreadInitialState,
  messageStatus: messageStatusInitialState,
};
